import { render } from "./CustomIdioma.vue?vue&type=template&id=493bb6da&scoped=true"
import script from "./CustomIdioma.vue?vue&type=script&lang=js"
export * from "./CustomIdioma.vue?vue&type=script&lang=js"

import "./CustomIdioma.vue?vue&type=style&index=0&id=493bb6da&lang=scss&scoped=true"

import exportComponent from "/workspace/projectes/suggestions/suggeriments-upcommons/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-493bb6da"]])

export default __exports__